import { type AiBudgetPriceDto } from "../services/magicAiPaymentService";
import { montserrat, getFormattedNumber, type Translationtype } from "utils";
import { BsStarFill, BsCheckCircleFill } from "react-icons/bs";

interface IAiBudgetPriceCardProps {
  pkg: AiBudgetPriceDto;
  isSelected: boolean;
  onSelect: (id: string) => void;
  t: Translationtype;
}

export function AiBudgetPriceCard({
  pkg,
  isSelected,
  onSelect,
  t,
}: IAiBudgetPriceCardProps) {
  const formattedPrice = getFormattedNumber(pkg.grossPrice, pkg.currencyCode);
  const formattedOldPrice = pkg.grossPriceBeforeDiscount
    ? getFormattedNumber(pkg.grossPriceBeforeDiscount, pkg.currencyCode)
    : null;

   const totalVideos = pkg.aiVideoCount;

  return (
    <div
      onClick={() => onSelect(pkg.id)}
      className={`${montserrat.className} relative cursor-pointer rounded-xl border-2 p-5 transition-all flex flex-col h-full
        ${isSelected ? "border-[#1e293b] shadow-xl scale-[1.02]" : "border-gray-200 shadow-md hover:shadow-lg"}
        ${pkg.isRecommended ? "ring-2 ring-amber-400" : ""}`}
    >
      {pkg.isRecommended && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-400 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 whitespace-nowrap">
          <BsStarFill className="text-[10px]" />
          {t("aiBudget.recommended")}
        </span>
      )}

      <h3 className="text-lg font-bold text-center mt-2">{pkg.name}</h3>

      <div className="flex items-center justify-center gap-2 my-3">
        {formattedOldPrice && (
          <span className="text-red-500 line-through text-lg font-semibold">
            {formattedOldPrice}
          </span>
        )}
        <span className="text-2xl font-extrabold">{formattedPrice}</span>
      </div>

      <ul className="space-y-2 text-sm flex-1">
        <li className="flex items-center gap-2">
          {t("aiBudget.maxGuests", { count: pkg.maxGuests })}
        </li>
        <li className="flex items-center gap-2">
          <BsCheckCircleFill className="text-green-500 flex-shrink-0" />
          {pkg.aiPhotoCount === 0
            ? t("aiBudget.unlimitedAiPhotos")
            : t("aiBudget.aiPhotos", { count: pkg.aiPhotoCount })}
        </li>
        {totalVideos > 0 && (
          <li className="flex items-center gap-2">
            <BsCheckCircleFill className="text-green-500 flex-shrink-0" />
            {t("aiBudget.aiVideos", { count: totalVideos })}
          </li>
        )}
        {pkg.includesIndividual && (
          <li className="flex items-center gap-2">
            <BsCheckCircleFill className="text-green-500 flex-shrink-0" />
            {t("aiBudget.includesIndividual")}
          </li>
        )}
      </ul>

      {isSelected && (
        <div className="mt-4 flex justify-center">
          <span className="bg-brandSuccess300 text-white text-xs font-bold uppercase px-4 py-1 rounded-full">
            {t("aiBudget.selected")}
          </span>
        </div>
      )}
    </div>
  );
}
